import React from 'react';
import { Modal } from 'react-bootstrap';

import styles from './MarkAsViewedModal.module.css';


function MarkAsViewedModal(props) {

  const {
    show,
    onHide,
    handleMarkAllAsViewed,
  } = props;

  const handleAction = () => {
    handleMarkAllAsViewed();
    onHide();
  };

  const handleCancel = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className={styles.modalTitle}
        >
          Mark all notifications as viewed
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <p>This action will mark all notifications as read, including new and unopened ones.</p>
        <div className={styles.modalButtonContainer}>
          <button
            onClick={handleCancel}
            className={styles.cancelButton}
          >
            Cancel
          </button>
          <button
            onClick={handleAction}
            className={styles.actionButton}
          >
            Mark As Viewed
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MarkAsViewedModal; 